<div class="container container--article container--clearHeader">
  <div class="bodyItem bodyItem--articleIntr">
    <div class="bodyItem__text">
      <div *ngIf="statusPaymentLoading$ | async; else default" class="basicLoader"></div>
      <ng-template #default>
        <section>
          <section class="mb-3 mt-3">
            <h1 *ngIf="hasPaymentFailed$ | async; else successTitle" class="headingXL pt-4 pb-1">
              {{ "CONFIRMATION.TITLE_FAILED" | translate }}
            </h1>
            <ng-template #successTitle>
              <nes-heading tag="h1" size="6xl" weight="normal" class="nes-pt-1 nes-pt-4">
                {{ "CONFIRMATION.TITLE" | translate }}</nes-heading>
            </ng-template>
          </section>
          <ng-container *ngIf="hasPaymentFailed$ | async; else successBody">
            <section>
              <div class="grid">
                <div class="grid__unit s-4-4 m-12-12 animated zoomIn">
                  <p>
                    {{ "CONFIRMATION.RETRY_TEXT" | translate }}
                  </p>
                  <button class="button" [cypress]="'retry_payment'" (click)="retryPayment()">
                    {{ "CONFIRMATION.BUTTON.RETRY" | translate }}
                  </button>
                </div>
              </div>
            </section>
          </ng-container>
          <ng-template #successBody>
            <section *ngIf="transaction$ | async as transaction" [cypress]="'transaction_result'">
              <div class="grid">
                <div class="grid__unit s-4-4 m-12-12 animated zoomIn">
                  <ng-container *ngIf="transaction.paymentStatus === PaymentStatus.Success">
                    <h2 class="headingS pb-1">
                      {{ "CONFIRMATION.REFNUMBER_DESCRIPTION" | translate }}
                      <strong>{{
                        transaction.referenceNumber | formatReference
                      }}</strong>
                    </h2>
                    <p class="pb-2">{{ "CONFIRMATION.INFO" | translate }}</p>
                    <hr class="articleSeparator" />
                  </ng-container>
                  <ng-container *ngIf="transaction.paymentStatus === PaymentStatus.Open">
                    <h2 class="headingS pb-1">
                      {{ "CONFIRMATION.PAYMENT_OPEN" | translate }}
                    </h2>
                  </ng-container>
                </div>
              </div>
            </section>
            <section *ngIf="representativeEmail$ | async as email" [cypress]="'user_result'">
              <div class="grid">
                <div class="grid__unit s-4-4">
                  <nes-heading tag="h3" size="4xl" weight="normal" class="nes-mb-3">
                    {{ "CONFIRMATION.EXPECT" | translate }}</nes-heading>
                  <div class="contactOption mb-3">
                    <i class="icon icon--xlarge contactOption__icon mail--large"></i>
                    <h3 class="headingXS">
                      <strong>
                        {{ "CONFIRMATION.EMAIL_TITLE" | translate }}
                      </strong>
                    </h3>
                    <p class="contactOption__text" privacySensitive>
                      {{ "CONFIRMATION.EMAIL_INFO" | translate }} {{ email }}
                    </p>
                  </div>
                  <div class="contactOption">
                    <i class="icon icon--xlarge contactOption__icon business-card--large"></i>
                    <h3 class="headingXS">
                      <strong>
                        {{ "CONFIRMATION.CARD_TITLE" | translate }}
                      </strong>
                    </h3>
                    <p class="contactOption__text">
                      {{ "CONFIRMATION.CARD_TEXT" | translate }}
                    </p>
                  </div>
                  <div class="contactOption">
                    <i class="icon icon--xlarge contactOption__icon chat--large"></i>
                    <h3 class="headingXS">
                      <strong>
                        {{ "CONFIRMATION.QUESTIONS_TITLE" | translate }}
                      </strong>
                    </h3>
                    <p class="contactOption__text" [innerHTML]="'CONFIRMATION.QUESTIONS_TEXT' | translate"></p>
                  </div>
                </div>
              </div>
            </section>
          </ng-template>
        </section>
      </ng-template>
      <div class="actionBar">
        <div class="actionBar__container actionBar__container--right">
          <nes-button variant="primary" [disabled]="statusPaymentLoading$ | async" (click)="resetState()">
            {{ "CONFIRMATION.BUTTON.BACK" | translate }}
          </nes-button>
        </div>
      </div>
    </div>
  </div>
</div>